(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('ImageStorageSearch', ImageStorageSearch);

    ImageStorageSearch.$inject = ['$resource'];

    function ImageStorageSearch($resource) {
        var resourceUrl =  'api/_search/image-storages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
